import { render, staticRenderFns } from "./MassiveRecommendationsCreation.vue?vue&type=template&id=6aa29997&lang=pug"
import script from "./MassiveRecommendationsCreation.vue?vue&type=script&lang=js"
export * from "./MassiveRecommendationsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports